var _g, _g2, _g3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgScuba(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "_x32_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, " .st0{fill:#ffffff;} "), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M39.588,405.243c-14.315,14.762-17.943,35.878-11.157,53.916l-13.79,18.515L60.751,512l14.558-19.565 l-0.094-0.062c13.837,0.337,27.776-4.819,38.182-15.537c19.761-20.388,19.26-52.928-1.129-72.704 C91.889,384.37,59.349,384.864,39.588,405.243z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M232.032,227.946c7.162-6.355,7.836-17.418,1.481-24.58l-33.527-37.79c-6.354-7.161-17.418-7.828-24.58-1.473 L151.249,185.4l56.634,63.835L232.032,227.946z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M123.45,323.27l75.313-65.942l-56.626-63.843l-75.321,65.942c-17.63,15.639-19.236,42.601-3.604,60.238 C78.851,337.296,105.812,338.909,123.45,323.27z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "337.018,203.154 344.931,149.67 322.827,104.938 356.213,32.282 304.642,0 274.147,120.382 309.069,210.661 "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M459.053,22.253l-98.154,85.655l-14.542,103.56l-60.896,15.184c-13.791,2.116-38.166,13.783-52.324,24.282 c-25.222,18.233-82.004,66.742-94.918,78.424c-51.133,46.338,3.863,100.966,40.415,97.675l95.371-9.661l74.083-5.532 c11.032,0.352,20.278-8.306,20.63-19.353c0.345-11.032-8.313-20.278-19.361-20.63l-73.793-3.558l-33.606-1.074 c0,0,56.704-51.314,59.086-53.405c1.316-1.159,0.705-0.909,2.758-2.272l74.004-42.428c9.692-4.395,26.342-12.662,30.01-36.474 l2.656-95.528l0.494-2.994l86.392-46.181L459.053,22.253z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScuba);
export default __webpack_public_path__ + "static/media/scuba.a66680e8c29dc5e0e3b34213e02ef358.svg";
export { ForwardRef as ReactComponent };